module.exports = __webpack_public_path__ + "static/media/logo-varzeapoco.987d257b.png";